export class Release {
    public ICES: string;
    public Year: number;
    public Count: number;
}